import React, { useRef, useEffect, useState } from "react"
import styled, { css } from "styled-components"
import SplashLottieData from "../../lotties/splash.json"
import lottie, { AnimationItem } from "lottie-web"

const SplashContainer = styled.div<{ animationDone: boolean }>`
  position: fixed;
  top: 0;
  height: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background-color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity ease 500ms;

  ${({ animationDone }): any =>
    animationDone
      ? css`
          opacity: 0;
          pointer-events: none;
        `
      : ""}
`

const LottieContainer = styled.div`
  width: 200px;
  max-width: 100%;
  height: 200px;
  max-height: 100%;
`

const SplashLottie: React.FC = () => {
  const lottieContainerRef = useRef<any>()
  const lottieRef = useRef<AnimationItem | null>(null)
  const [animationDone, setAnimationDone] = useState(false)

  useEffect(() => {
    const onLottieComplete = () => {
      document.body.style.overflowY = "auto"
      setAnimationDone(true)
    }

    const init = (): void => {
      document.body.style.opacity = "1"
      if (lottieContainerRef.current) {
        lottieRef.current = lottie.loadAnimation({
          container: lottieContainerRef.current,
          renderer: "canvas",
          loop: false,
          autoplay: true,
          animationData: SplashLottieData,
        })

        // ignoring as types not complete
        // @ts-ignore
        lottieRef.current.onComplete = onLottieComplete
        lottieRef.current.setSpeed(1.2)
      }
    }

    const destroy = (): void => {
      lottieRef.current?.destroy()
    }

    init()

    return (): void => {
      destroy()
    }
  }, [])

  return (
    <>
      <SplashContainer animationDone={animationDone}>
        <LottieContainer ref={lottieContainerRef} />
      </SplashContainer>
    </>
  )
}

export default SplashLottie
